// extracted by mini-css-extract-plugin
export default {"subTitle":"SystemActionLog_subTitle__UTi2z","errorMessage":"SystemActionLog_errorMessage__Ewh3v"};